<template>
    <div>
        <ChartComponent :charts="charts" />
        <div class="caseline-container">
            <q-table :rows="data" :columns="filteredCaseColumns" :loading="loading" :rows-per-page-options="[20]" :filter="caseFilter">
                <template v-slot:top-left>
                    <div class="users-title view-user-title">
                        <q-input outlined dense debounce="300" v-model="caseFilter" placeholder="Search Table">
                            <template v-slot:append>
                                <q-icon name="close" @click="caseFilter = ''" class="cursor-pointer" />
                                <q-icon name="search" />
                            </template>
                        </q-input>
                        <q-select v-model="caseVisibleColumns" multiple outlined dense options-dense
                            clearable
                            :display-value="$q.lang.table.columns" emit-value map-options
                            :options="caseTableColumns" option-value="value"
                            style="min-width: 150px; margin-bottom: 0;" />
                    </div>
                </template>
                <template v-slot:top-right>
                    <div style="display: flex; align-items: flex-start; gap: 1rem;">
                        <FileUploadComponent endpoint="/app/report/asa/active-cases" label="ASA File Upload" @uploaded="() => api.map.populateStatisticalAreas()" />
                        <q-btn no-caps fab-mini flat icon="download" @click="exportTable(getVisibleRows(data, caseVisibleColumns), 'ASA Case Data.csv', { columns: caseDataColumns })" />
                    </div>
                </template>
                <template v-slot:body-cell="props">
                    <q-td :props="props">
                        <span v-if="props.value && props.col.name.includes('date')">
                            {{ props.value.split('T')[0] }}
                        </span>
                        <span v-else>
                            {{ props.value }}
                        </span>
                    </q-td>
                </template>
            </q-table>
        </div>
    </div>
</template>

<script>
import FileUploadComponent from "../FileUploadComponent.vue"
import ChartComponent from "./ChartComponent.vue";
import { exportTable, getVisibleRows } from "../../services/util/file";
import api from "../../services/api/api";

export default {
    components: {
        FileUploadComponent,
        ChartComponent,
    },
    props: {
        data: {
            type: Array,
        },
        charts: {
            type: Array,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            api: api,
            exportTable: exportTable,
            getVisibleRows: getVisibleRows,
            caseDataColumns: [
                { name: 'display_id', label: 'Case ID', align: 'left', field: row => row.display_id },
                { name: 'type', label: 'Type', align: 'left', field: row => row.type },
                { name: 'referrer_school', label: 'Referrer School', align: 'left', field: row => row.referrer_school },
                { name: 'nsn', label: 'NSN', align: 'left', field: row => row.nsn },
                { name: 'Status', label: 'Status', align: 'left', field: row => row.status, sortable: true },
                { name: 'date_started', label: 'Date Started', align: 'left', field: row => row.date_started, sortable: true },
                { name: 'date_lodged', label: 'Date Lodged', align: 'left', field: row => row.date_lodged, sortable: true },
                { name: 'time_case_open', label: 'Days (Started -> Lodged)', align: 'left', field: row => row.time_case_open, sortable: true},
                { name: 'age_at_referral', label: 'Age at Referral', align: 'left', field: row => row.age_at_referral },
                { name: 'confirmed_address', label: 'Confirmed Address', align: 'left', field: row => row.confirmed_address },
                { name: 'current_year_level', label: 'Current Year Level', align: 'left', field: row => row.current_year_level },
                { name: 'currently_enrolled', label: 'Currently Enrolled', align: 'left', field: row => row.currently_enrolled },
                { name: 'date_of_birth', label: 'Date of Birth', align: 'left', field: row => row.date_of_birth },
                { name: 'ethnicity', label: 'Ethnicity', align: 'left', field: row => row.ethnicity },
                { name: 'gender', label: 'Gender', align: 'left', field: row => row.gender },
                { name: 'iwi', label: 'Iwi', align: 'left', field: row => row.iwi },
                { name: 'iwi_2', label: 'Iwi 2', align: 'left', field: row => row.iwi_2 },
                { name: 'iwi_3', label: 'Iwi 3', align: 'left', field: row => row.iwi_3 },
                { name: 'provider_service_area', label: 'Provider Service Area', align: 'left', field: row => row.provider_service_area },
            ],
            caseTableColumns: [],
            caseVisibleColumns: [],
            caseFilter: null,
        }
    },

    computed: {
        filteredCaseColumns() {
        // Filter the columns based on caseVisibleColumns
        return this.caseDataColumns.filter(column => 
            this.caseVisibleColumns.includes(column.name)
        );
        },
    },

    created() {
    this.caseTableColumns = this.caseDataColumns.map((column) => ({
        value: column.name,
        label: column.label,
    }));
    this.caseVisibleColumns = this.caseTableColumns.map((col) => col.value);
    },
}
</script>

<style scoped>

</style>